<template>
  <div>
    <div class="small" v-if="device">
      <div
        class="d-flex align-items-center"
        v-if="device?.location && (device?.location?.city || device?.location?.region)"
      >
        Location:
        <a @click="showLocationModal" v-b-tooltip.hover title="Show Map" class="ml-2">
          {{ device.location.city }}, {{ device.location.region }}
        </a>
      </div>
      <div v-if="device?.referrer" class="overflow-hidden">
        Referrer:<a
          class="text-truncate ml-2"
          :href="device?.referrer"
          :title="device?.referrer"
          target="_blank"
          v-b-tooltip
          >{{ referrerDomain }}</a
        >
      </div>
      <div v-if="device?.userAgent?.device" class="d-flex align-items-center">
        Device:
        <i
          v-if="device.userAgent.device?.type"
          :class="`far fa-fw fa-${deviceIcon}`"
          class="ml-2"
          v-b-tooltip.hover="{ title: device.userAgent.device.type, html: true }"
        ></i>
      </div>
    </div>
    <b-modal ref="deviceModal" size="md" :hide-footer="true" :hide-header="true">
      <div class="card card-img-top" v-if="device?.location">
        <google-map
          :width="'100%'"
          :height="'300px'"
          :markers="[{ lat: device.location.latitude, lng: device.location.longitude }]"
          :zoom="7"
          :search="false"
        ></google-map>
      </div>
      <div class="mt-3" v-if="device">
        <div v-if="device?.location">
          <h3>{{ device.location.city }}, {{ device.location.region }}</h3>
          <div class="small">{{ device.location.ip }}</div>
        </div>
        <div class="mt-2 mb-3">
          <div class="small">Device</div>
          {{ device.type | capitalize }}
        </div>
        <div v-if="device?.userAgent" class="mt-3">
          <div class="small">OS</div>
          {{ device.userAgent.os.name | capitalize }}
        </div>
        <div v-if="device?.referrer" class="mt-3">
          <div class="small">Referrer</div>
          <a target="_blank" class="small" :href="device?.referrer"
            >{{ device.referrer }}<i class="ml-2 fa fa-external-link"></i
          ></a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
var psl = require('psl');

export default {
  props: {
    device: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      referrerDomain: ''
    };
  },
  computed: {
    deviceIcon() {
      return this.device.userAgent.device.type || 'desktop';
    }
  },
  created() {
    this.parseReferrer();
  },
  methods: {
    parseReferrer() {
      if (this.device?.referrer) {
        const parsed = psl.parse(new URL(this.device.referrer).hostname);
        this.referrerDomain = parsed.domain || this.device.referrer;
      }
    },
    showLocationModal() {
      this.$refs.deviceModal.show();
    }
  }
};
</script>
